<template>
	<div class="jw-chip-buttons" role="group">
		<slot></slot>
	</div>
</template>

<style lang="scss">
.jw-chip-buttons {
	display: flex;
	text-align: center;

	.jw-chip-button {
		width: 100%;
		border-inline-end-width: 0px !important;
		margin-inline-end: 0;
		margin-bottom: 0;

		&:last-child {
			border-inline-end-width: 1px !important;
		}
	}
}
</style>
